export class UserGroupLineModel {

  constructor(public Id: number, public Selected: boolean, public CanSetSupervisor: boolean) {
  }
}
